import type { OverlayToasterProps } from "@blueprintjs/core";
import { OverlayToaster } from "@blueprintjs/core";
import type { PropsWithChildren } from "react";
import { useEffect, useState } from "react";
import type { ToasterProps } from "./use-toaster";
import { ToasterContext } from "./use-toaster";

type ToasterProviderProps = {
  toasterprops?: OverlayToasterProps;
};

export function ToasterProvider({
  toasterprops,
  children,
}: PropsWithChildren<ToasterProviderProps>) {
  const [props, setProps] = useState<ToasterProps>({});

  useEffect(
    function effectToasterInitialize() {
      const init = async () =>
        setProps({
          toaster: await OverlayToaster.createAsync(toasterprops),
        });

      init();
    },
    [toasterprops],
  );

  return (
    <ToasterContext.Provider value={props}>{children}</ToasterContext.Provider>
  );
}
